export default __webpack_public_path__ + "static/media/Brow_5_C2.c1504572.svg";